export {
  Hero,
  LinkProxy,
  TextWrapper,
  HeroImageContainer,
  ErrorImage,
  CatImage,
} from './styles';
